import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import { ToastGroup } from '@famly/mf_data-display_toast';
import { getTabBarHeight } from 'web-app/react/navigation-v2/helpers';
/**
 * Clears the top bar, so the toasts do not cover the navigation.
 */
const TOP_BAR_OFFSET = 60;
/**
 * A modal covers the top bar, so with a modal open there is nothing up there to clear and the
 * toasts move to the edge of the viewport instead of appearing to float over the overlay.
 */
const MODAL_OPEN_TOP_OFFSET = 4;
/**
 * Room between the toasts and the bottom navigation on a narrow screen.
 */
const TAB_BAR_GAP = 15;
export const GlobalEventToasts = ({ events, clearStatus, isShowingModals, size }) => {
    const theme = useTheme();
    return (_jsx(ToastGroup, { events: events, clearStatus: clearStatus, size: size, topOffset: isShowingModals ? MODAL_OPEN_TOP_OFFSET : TOP_BAR_OFFSET, bottomOffset: getTabBarHeight(theme) + TAB_BAR_GAP, "data-e2e-id": "global-event-container" }));
};
